// 固定大小廣告
import AdSlot, { AD_EMPTY_EVENT, AD_RENDERED_EVENT } from './lib/adslot/adslot';
// 動態變換大小廣告, 例如新聞內頁最上方Banner, 因為是RWD桌機版是970x250, 手機版變成300x250
import type { Profile } from './lib/adslot/adslot';
import DynamicAdSlot from './lib/dynamicAdslot/dynamicAdslot';

export { Initialize } from './lib/initialize/initialize';
export { AD_EMPTY_EVENT, AD_RENDERED_EVENT, AdSlot, DynamicAdSlot, Profile };
export default { AdSlot, DynamicAdSlot, AD_RENDERED_EVENT, AD_EMPTY_EVENT };
